var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import AuthStream from "@irati/auth/streams/auth";
import UnauthedStream from "@irati/auth/streams/unauthed";
import ObserveWithPriority from "@irati/auth/helpers/auth/ObserveWithPriority";
import getClientDetails from "@irati/utils/services/apollo/helpers/getClientDetails";
import env from "../../env";
var Intercom = /** @class */ (function () {
    function Intercom() {
        var _this = this;
        this.setup();
        var isIdentitySet = false;
        setTimeout(function () {
            new ObserveWithPriority({ streams: [AuthStream, UnauthedStream], key: "user" }).subscribe(function (data) {
                if (data && data.user && data.business) {
                    if (!isIdentitySet) {
                        _this.setIdentity(data.user, data.business);
                        isIdentitySet = true;
                    }
                    else {
                        _this.updateIdentity(data.user, data.business);
                    }
                }
                else {
                    _this.clearIdentity();
                }
            });
        });
    }
    Intercom.prototype.getClientVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var clientDetails, data, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientDetails()];
                    case 1:
                        clientDetails = _a.sent();
                        data = {};
                        key = "version_" + clientDetails.name;
                        data[key] = clientDetailsToVersion(clientDetails);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    Intercom.prototype.logError = function (_a) {
        var _b, _c;
        var errorData = _a.errorData, metadata = __rest(_a, ["errorData"]);
        return __awaiter(this, void 0, void 0, function () {
            var formattedErrorData, clientDetails, e_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        formattedErrorData = ((_c = (_b = errorData === null || errorData === void 0 ? void 0 : errorData.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.errorData) || {};
                        if (Object.keys(formattedErrorData).length) {
                            metadata.errorData = JSON.stringify(errorData.errors[0].errorData);
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getClientDetails()];
                    case 2:
                        clientDetails = _d.sent();
                        metadata.version = clientDetails.name + " " + clientDetailsToVersion(clientDetails);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, this.logEvent("loggedError", metadata)];
                }
            });
        });
    };
    return Intercom;
}());
export default Intercom;
function clientDetailsToVersion(clientDetails) {
    if (clientDetails.name === "web") {
        return clientDetails.version + " (" + env.BUNDLE_REF + ")";
    }
    return "" + clientDetails.version;
}
